/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_SourceInputs */

const en_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue Source`)
};

const fr_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source du dialogue`)
};

const de_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogquelle`)
};

const it_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte del dialogo`)
};

const ru_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник диалога`)
};

const es_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente del diálogo`)
};

const zh_cn2_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话来源`)
};

const ja_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対話の出典`)
};

const hi_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद स्रोत`)
};

const pt_pt2_dialogue_source = /** @type {(inputs: Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte do diálogo`)
};

/**
* | output |
* | --- |
* | "Dialogue Source" |
*
* @param {Dialogue_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_source = /** @type {((inputs?: Dialogue_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_source(inputs)
	if (locale === "de") return de_dialogue_source(inputs)
	if (locale === "it") return it_dialogue_source(inputs)
	if (locale === "ru") return ru_dialogue_source(inputs)
	if (locale === "es") return es_dialogue_source(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_source(inputs)
	if (locale === "ja") return ja_dialogue_source(inputs)
	if (locale === "hi") return hi_dialogue_source(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_source(inputs)
	return en_dialogue_source(inputs)
});